import { Popper } from "@mui/material";

/**
 * @typedef {import('@mui/material').PopperProps} PopperProps
 */

/**
 * A shared Popper component that maintains consistent width with its anchor element
 * @param {PopperProps} props - The Popper props
 * @returns {JSX.Element} The Popper component
 */
const AnchorPopper = (props) => {
  const { anchorEl } = props;
  const width =
    anchorEl instanceof HTMLElement ? anchorEl.offsetWidth : undefined;

  return (
    <Popper {...props} style={{ minWidth: width }}>
      {props.children}
    </Popper>
  );
};

export default AnchorPopper;
